<kendo-chart class="asap-kendo-donut-chart">
    <kendo-chart-area [background]="chartAreaBack">
    </kendo-chart-area>
    <ng-template kendoChartDonutCenterTemplate>
        <div class="donut-chart-center-wrapper">
            <span class="donut-chart-title-span">Total Qty</span>
            <h3 class="donut-chart-title">{{ sum | number }}</h3>
        </div>
    </ng-template>
    <kendo-chart-tooltip [visible]="_tooltipVisibility">
        <ng-template kendoChartSeriesTooltipTemplate let-value="value" let-category="category" let-point="point">
            <div class="asap-chart-tooltip-badge">
                <span class="tooltip-color-indicator" [style.background-color]="point?.color || '#1E88E5'"></span>
                <span class="tooltip-category-text">{{ category }}:</span>
                <strong class="tooltip-value-text">{{ value | number }}</strong>
            </div>
        </ng-template>
    </kendo-chart-tooltip>
    <kendo-chart-series>
        <kendo-chart-series-item type="donut" [startAngle]="90" [holeSize]="55" [data]="$safeNavigationMigration(ChartDataName?.data)" field="value"
            categoryField="category" colorField="color">
            <kendo-chart-series-item-labels [color]="labelColor" [content]="labelContent" background="none"
                [font]="labelFont">
            </kendo-chart-series-item-labels>
        </kendo-chart-series-item>
    </kendo-chart-series>
    <kendo-chart-legend [visible]="false"></kendo-chart-legend>
</kendo-chart>

